"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MSOneDrive = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.101 5.596 3.36 2.012 2-.843a3.239 3.239 0 0 1 1.509-.257 5 5 0 0 0-9.02-1.507L4 5a3.98 3.98 0 0 1 2.101.596Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.101 5.596A3.98 3.98 0 0 0 3.999 5l-.05.001a3.998 3.998 0 0 0-3.23 6.285l2.96-1.246 1.317-.554 2.932-1.234 1.531-.644-3.358-2.012Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.97 6.508a3.239 3.239 0 0 0-1.508.258l-2.001.842.58.348 1.903 1.139.83.497 2.838 1.7a3.25 3.25 0 0 0-2.642-4.784Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.774 9.592-.83-.497-1.903-1.14-.58-.347-1.531.644-2.932 1.234-1.317.554-2.962 1.247A3.995 3.995 0 0 0 4 13h8.75a3.25 3.25 0 0 0 2.861-1.708l-2.838-1.7Z",
    fill: "#28A8EA"
  })));
});
var _default = MSOneDrive;
exports["default"] = _default;